import { Filter } from '@material-ui/icons';
import { isEmpty, find, filter, isUndefined} from 'lodash'

const initialState = {
  isFetchingCommunityPropertyData: false,
  isFetchingRealEstate: false,
  isFetchingHouseHold: false,
  isFetchingJewelary: false,
  isFetchingVehicles: false,
  isFetchingSavings: false,
  isFetchingChecking: false,
  isFetchingCredit: false,
  isFetchingCash: false,
  isFetchingTaxRefund: false,
  isFetchingLifeInsurance: false,
  isFetchingStocks: false,
  isFetchingRetirements: false,
  isFetchingProfit: false,
  isFetchingAccounts: false,
  isFetchingPartnership: false,
  isFetchingOtherAssets: false,
  isFetchingContinuationAssets: false,
  isFetchingDeleteCommunityAssets: false,
  isFetchingDeleteCommunityDebits: false,

  isFetchingDescriptionData: false,
  descriptionOptions: [],
  isFetchingSecondTableCommunityPropertyData: false,

  isFetchingStudentLoans: false,
  isFetchingTaxes: false,
  isFetchingSupport: false,
  isFetchingLoans: false,
  isFetchingCreditCards: false,
  isFetchingDebts: false,
  isFetchingContinuationDebts: false,

  isFetchingSecondTableDescriptionData: false,
  isFetchingGetData: false,
  realEstate: [{
    brief_desc: '',
    date_acquired: '',
    gfmv: "0.0",
    aod: '0.0',
    nfmv: '0.0',
    pfdp: '0.0',
    pfdr: '0.0',
  }],

  household: [{
    brief_desc: '',
    date_acquired: '',
    gfmv: "0.0",
    aod: '0.0',
    nfmv: '0.0',
     pfdp: '0.0',
    pfdr: '0.0',
  }],

  jewelary: [{
    brief_desc: '',
    date_acquired: '',
    gfmv: "0.0",
    aod: '0.0',
    nfmv: '0.0',
     pfdp: '0.0',
    pfdr: '0.0',
  }],

  vehicles: [{
    brief_desc: '',
    date_acquired: '',
    gfmv: "0.0",
    aod: '0.0',
    nfmv: '0.0',
     pfdp: '0.0',
    pfdr: '0.0',
  }],

  savings: [{
    brief_desc: '',
    date_acquired: '',
    gfmv: "0.0",
    aod: '0.0',
    nfmv: '0.0',
     pfdp: '0.0',
    pfdr: '0.0',
  }],

  checking: [{
    brief_desc: '',
    date_acquired: '',
    gfmv: "0.0",
    aod: '0.0',
    nfmv: '0.0',
     pfdp: '0.0',
    pfdr: '0.0',
  }],

  credit: [{
    brief_desc: '',
    date_acquired: '',
    gfmv: "0.0",
    aod: '0.0',
    nfmv: '0.0',
     pfdp: '0.0',
    pfdr: '0.0',
  }],

  cash: [{
    brief_desc: '',
    date_acquired: '',
    gfmv: "0.0",
    aod: '0.0',
    nfmv: '0.0',
     pfdp: '0.0',
    pfdr: '0.0',
  }],

  taxRefund: [{
    brief_desc: '',
    date_acquired: '',
    gfmv: "0.0",
    aod: '0.0',
    nfmv: '0.0',
     pfdp: '0.0',
    pfdr: '0.0',
  }],

  lifeInsurance: [{
    brief_desc: '',
    date_acquired: '',
    gfmv: "0.0",
    aod: '0.0',
    nfmv: '0.0',
     pfdp: '0.0',
    pfdr: '0.0',
  }],

  stocks: [{
    brief_desc: '',
    date_acquired: '',
    gfmv: "0.0",
    aod: '0.0',
    nfmv: '0.0',
     pfdp: '0.0',
    pfdr: '0.0',
  }],

  retirements: [{
    brief_desc: '',
    date_acquired: '',
    gfmv: "0.0",
    aod: '0.0',
    nfmv: '0.0',
     pfdp: '0.0',
    pfdr: '0.0',
  }],

  profit: [{
    brief_desc: '',
    date_acquired: '',
    gfmv: "0.0",
    aod: '0.0',
    nfmv: '0.0',
     pfdp: '0.0',
    pfdr: '0.0',
  }],

  accounts: [{
    brief_desc: '',
    date_acquired: '',
    gfmv: "0.0",
    aod: '0.0',
    nfmv: '0.0',
     pfdp: '0.0',
    pfdr: '0.0',
  }],

  partnership: [{
    brief_desc: '',
    date_acquired: '',
    gfmv: "0.0",
    aod: '0.0',
    nfmv: '0.0',
     pfdp: '0.0',
    pfdr: '0.0',
  }],

  otherAssets: [{
    brief_desc: '',
    date_acquired: '',
    gfmv: "0.0",
    aod: '0.0',
    nfmv: '0.0',
     pfdp: '0.0',
    pfdr: '0.0',
  }],

  continuationAssets: [{
    brief_desc: '',
    date_acquired: '',
    gfmv: "0.0",
    aod: '0.0',
    nfmv: '0.0',
     pfdp: '0.0',
    pfdr: '0.0',
  }],

  studentLoans: [{
    debt_description: '',
    debts_date_incurred: '',
    debts_total_owing: '0.0',
    debts_pdap: '0.0',
    debts_pdcr: '0.0',
  }],

  taxes: [{
    debt_description: '',
    debts_date_incurred: '',
    debts_total_owing: '0.0',
    debts_pdap: '0.0',
    debts_pdcr: '0.0',
  }],

  support: [{
    debt_description: '',
    debts_date_incurred: '',
    debts_total_owing: '0.0',
    debts_pdap: '0.0',
    debts_pdcr: '0.0',
  }],

  loans: [{
    debt_description: '',
    debts_date_incurred: '',
    debts_total_owing: '0.0',
    debts_pdap: '0.0',
    debts_pdcr: '0.0',
  }],

  creditCards: [{
    debt_description: '',
    debts_date_incurred: '',
    debts_total_owing: '0.0',
    debts_pdap: '0.0',
    debts_pdcr: '0.0',
  }],

  debts: [{
    debt_description: '',
    debts_date_incurred: '',
    debts_total_owing: '0.0',
    debts_pdap: '0.0',
    debts_pdcr: '0.0',
  }],

  continuationDebts: [{
    debt_description: '',
    debts_date_incurred: '',
    debts_total_owing: '0.0',
    debts_pdap: '0.0',
    debts_pdcr: '0.0',
  }],
};

const communityPropertyReducer = (state = initialState, action) => {
  switch (action.type) {
    case "REQUEST_POST_COMMUNITY_PROPERTY":
      return { ...state, isFetchingCommunityPropertyData: true };
    case "SUCCESS_POST_COMMUNITY_PROPERTY":
      return { ...state, isFetchingCommunityPropertyData: false };
    case "ERROR_POST_COMMUNITY_PROPERTY":
      return { ...state, isFetchingCommunityPropertyData: false };

    case "REQUEST_REAL_ESTATE":
      return { ...state, isFetchingRealEstate: true };
    case "SUCCESS_REAL_ESTATE":
      return { ...state, isFetchingRealEstate: false, realEstate: action.payload.data };
    case "ERROR_REAL_ESTATE":
      return { ...state, isFetchingRealEstate: false };

    case "REQUEST_HOUSE_HOLD":
      return { ...state, isFetchingHouseHold: true };
    case "SUCCESS_HOUSE_HOLD":
      return { ...state, isFetchingHouseHold: false, household: action.payload.data };
    case "ERROR_HOUSE_HOLD":
      return { ...state, isFetchingHouseHold: false };

    case "REQUEST_JEWELARY":
      return { ...state, isFetchingJewelary: true };
    case "SUCCESS_JEWELARY":
      return { ...state, isFetchingJewelary: false, jewelary: action.payload.data };
    case "ERROR_JEWELARY":
      return { ...state, isFetchingJewelary: false };

    case "REQUEST_VEHICLES":
      return { ...state, isFetchingVehicles: true };
    case "SUCCESS_VEHICLES":
      return { ...state, isFetchingVehicles: false, vehicles: action.payload.data };
    case "ERROR_VEHICLES":
      return { ...state, isFetchingVehicles: false };

    case "REQUEST_SAVINGS":
      return { ...state, isFetchingSavings: true };
    case "SUCCESS_SAVINGS":
      return { ...state, isFetchingSavings: false, savings: action.payload.data };
    case "ERROR_SAVINGS":
      return { ...state, isFetchingSavings: false };

    case "REQUEST_CHECKING":
      return { ...state, isFetchingChecking: true };
    case "SUCCESS_CHECKING":
      console.log(action.payload, "action")
      return { ...state, isFetchingChecking: false, checking: action.payload.data };
    case "ERROR_CHECKING":
      return { ...state, isFetchingChecking: false };

    case "REQUEST_CREDIT":
      return { ...state, isFetchingCredit: true };
    case "SUCCESS_CREDIT":
      return { ...state, isFetchingCredit: false, credit: action.payload.data };
    case "ERROR_CREDIT":
      return { ...state, isFetchingCredit: false };

    case "REQUEST_CASH":
      return { ...state, isFetchingCash: true };
    case "SUCCESS_CASH":
      return { ...state, isFetchingCash: false, cash: action.payload.data };
    case "ERROR_CASH":
      return { ...state, isFetchingCash: false };

    case "REQUEST_TAX_REFUND":
      return { ...state, isFetchingTaxRefund: true };
    case "SUCCESS_TAX_REFUND":
      return { ...state, isFetchingTaxRefund: false, taxRefund: action.payload.data };
    case "ERROR_TAX_REFUND":
      return { ...state, isFetchingTaxRefund: false };

    case "REQUEST_LIFE_INSURANCE":
      return { ...state, isFetchingLifeInsurance: true };
    case "SUCCESS_LIFE_INSURANCE":
      return { ...state, isFetchingLifeInsurance: false, lifeInsurance: action.payload.data };
    case "ERROR_LIFE_INSURANCE":
      return { ...state, isFetchingLifeInsurance: false };

    case "REQUEST_STOCKS":
      return { ...state, isFetchingStocks: true };
    case "SUCCESS_STOCKS":
      return { ...state, isFetchingStocks: false, stocks: action.payload.data };
    case "ERROR_STOCKS":
      return { ...state, isFetchingStocks: false };

    case "REQUEST_RETIREMENTS":
      return { ...state, isFetchingRetirements: true };
    case "SUCCESS_RETIREMENTS":
      return { ...state, isFetchingRetirements: false, retirements: action.payload.data };
    case "ERROR_RETIREMENTS":
      return { ...state, isFetchingRetirements: false };

    case "REQUEST_PROFIT":
      return { ...state, isFetchingProfit: true };
    case "SUCCESS_PROFIT":
      return { ...state, isFetchingProfit: false, profit: action.payload.data };
    case "ERROR_PROFIT":
      return { ...state, isFetchingProfit: false };

    case "REQUEST_ACCOUNTS":
      return { ...state, isFetchingAccounts: true };
    case "SUCCESS_ACCOUNTS":
      return { ...state, isFetchingAccounts: false, accounts: action.payload.data };
    case "ERROR_ACCOUNTS":
      return { ...state, isFetchingAccounts: false };

    case "REQUEST_PARTNERSHIP":
      return { ...state, isFetchingPartnership: true };
    case "SUCCESS_PARTNERSHIP":
      return { ...state, isFetchingPartnership: false, partnership: action.payload.data };
    case "ERROR_PARTNERSHIP":
      return { ...state, isFetchingPartnership: false };

    case "REQUEST_OTHER_ASSETS":
      return { ...state, isFetchingOtherAssets: true };
    case "SUCCESS_OTHER_ASSETS":
      return { ...state, isFetchingOtherAssets: false, otherAssets: action.payload.data };
    case "ERROR_OTHER_ASSETS":
      return { ...state, isFetchingOtherAssets: false };

    case "REQUEST_CONTINUATION_ASSETS":
      return { ...state, isFetchingContinuationAssets: true };
    case "SUCCESS_CONTINUATION_ASSETS":
      return { ...state, isFetchingContinuationAssets: false, continuationAssets: action.payload.data };
    case "ERROR_CONTINUATION_ASSETS":
      return { ...state, isFetchingContinuationAssets: false };



    case "REQUEST_GET_COMMUNITY_PROPERTY":
      return { ...state, isFetchingDescriptionData: true };
    case "SUCCESS_GET_COMMUNITY_PROPERTY":
      return { ...state, descriptionOptions: action.payload, isFetchingDescriptionData: false };
    case "ERROR_GET_COMMUNITY_PROPERTY":
      return { ...state, isFetchingDescriptionData: false };



    case "REQUEST_POST_SECOND_TABLE_COMMUNITY_PROPERTY":
      return { ...state, isFetchingSecondTableCommunityPropertyData: true };
    case "SUCCESS_POST_SECOND_TABLE_COMMUNITY_PROPERTY":
      return { ...state, isFetchingSecondTableCommunityPropertyData: false };
    case "ERROR_POST_SECOND_TABLE_COMMUNITY_PROPERTY":
      return { ...state, isFetchingSecondTableCommunityPropertyData: false };

    case "REQUEST_STUDENT_LOANS":
      return { ...state, isFetchingStudentLoans: true };
    case "SUCCESS_STUDENT_LOANS":
      return { ...state, isFetchingStudentLoans: false, studentLoans: action.payload.data };
    case "ERROR_STUDENT_LOANS":
      return { ...state, isFetchingStudentLoans: false };

    case "REQUEST_TAXES":
      return { ...state, isFetchingTaxes: true };
    case "SUCCESS_TAXES":
      return { ...state, isFetchingTaxes: false, taxes: action.payload.data };
    case "ERROR_TAXES":
      return { ...state, isFetchingTaxes: false };

    case "REQUEST_SUPPORT":
      return { ...state, isFetchingSupport: true };
    case "SUCCESS_SUPPORT":
      return { ...state, isFetchingSupport: false, support: action.payload.data };
    case "ERROR_SUPPORT":
      return { ...state, isFetchingSupport: false };

    case "REQUEST_LOANS":
      return { ...state, isFetchingLoans: true };
    case "SUCCESS_LOANS":
      return { ...state, isFetchingLoans: false, loans: action.payload.data };
    case "ERROR_LOANS":
      return { ...state, isFetchingLoans: false };

    case "REQUEST_CREDIT_CARDS":
      return { ...state, isFetchingCreditCards: true };
    case "SUCCESS_CREDIT_CARDS":
      return { ...state, isFetchingCreditCards: false, creditCards: action.payload.data };
    case "ERROR_CREDIT_CARDS":
      return { ...state, isFetchingCreditCards: false };

    case "REQUEST_DEBTS":
      return { ...state, isFetchingDebts: true };
    case "SUCCESS_DEBTS":
      return { ...state, isFetchingDebts: false, debts: action.payload.data };
    case "ERROR_DEBTS":
      return { ...state, isFetchingDebts: false };

    case "REQUEST_CONTINUATION_DEBTS":
      return { ...state, isFetchingContinuationDebts: true };
    case "SUCCESS_CONTINUATION_DEBTS":
      return { ...state, isFetchingContinuationDebts: false, continuationDebts: action.payload.data };
    case "ERROR_CONTINUATION_DEBTS":
      return { ...state, isFetchingContinuationDebts: false };



    case "REQUEST_GET_DATA":
      return { ...state,  isFetchingCommunityPropertyData: false,
        isFetchingRealEstate: false,
        isFetchingHouseHold: false,
        isFetchingJewelary: false,
        isFetchingVehicles: false,
        isFetchingSavings: false,
        isFetchingChecking: false,
        isFetchingCredit: false,
        isFetchingCash: false,
        isFetchingTaxRefund: false,
        isFetchingLifeInsurance: false,
        isFetchingStocks: false,
        isFetchingRetirements: false,
        isFetchingProfit: false,
        isFetchingAccounts: false,
        isFetchingPartnership: false,
        isFetchingOtherAssets: false,
        isFetchingContinuationAssets: false,
      
        isFetchingDescriptionData: false,
        descriptionOptions: [],
        isFetchingSecondTableCommunityPropertyData: false,
      
        isFetchingStudentLoans: false,
        isFetchingTaxes: false,
        isFetchingSupport: false,
        isFetchingLoans: false,
        isFetchingCreditCards: false,
        isFetchingDebts: false,
        isFetchingContinuationDebts: false,
      
        isFetchingSecondTableDescriptionData: false,
        isFetchingGetData: true,
        realEstate: [{
          brief_desc: '',
          date_acquired: '',
          gfmv: "0.0",
          aod: '0.0',
          nfmv: '0.0',
          pfdp: '0.0',
          pfdr: '0.0',
        }],
      
        household: [{
          brief_desc: '',
          date_acquired: '',
          gfmv: "0.0",
          aod: '0.0',
          nfmv: '0.0',
           pfdp: '0.0',
          pfdr: '0.0',
        }],
      
        jewelary: [{
          brief_desc: '',
          date_acquired: '',
          gfmv: "0.0",
          aod: '0.0',
          nfmv: '0.0',
           pfdp: '0.0',
          pfdr: '0.0',
        }],
      
        vehicles: [{
          brief_desc: '',
          date_acquired: '',
          gfmv: "0.0",
          aod: '0.0',
          nfmv: '0.0',
           pfdp: '0.0',
          pfdr: '0.0',
        }],
      
        savings: [{
          brief_desc: '',
          date_acquired: '',
          gfmv: "0.0",
          aod: '0.0',
          nfmv: '0.0',
           pfdp: '0.0',
          pfdr: '0.0',
        }],
      
        checking: [{
          brief_desc: '',
          date_acquired: '',
          gfmv: "0.0",
          aod: '0.0',
          nfmv: '0.0',
           pfdp: '0.0',
          pfdr: '0.0',
        }],
      
        credit: [{
          brief_desc: '',
          date_acquired: '',
          gfmv: "0.0",
          aod: '0.0',
          nfmv: '0.0',
           pfdp: '0.0',
          pfdr: '0.0',
        }],
      
        cash: [{
          brief_desc: '',
          date_acquired: '',
          gfmv: "0.0",
          aod: '0.0',
          nfmv: '0.0',
           pfdp: '0.0',
          pfdr: '0.0',
        }],
      
        taxRefund: [{
          brief_desc: '',
          date_acquired: '',
          gfmv: "0.0",
          aod: '0.0',
          nfmv: '0.0',
           pfdp: '0.0',
          pfdr: '0.0',
        }],
      
        lifeInsurance: [{
          brief_desc: '',
          date_acquired: '',
          gfmv: "0.0",
          aod: '0.0',
          nfmv: '0.0',
           pfdp: '0.0',
          pfdr: '0.0',
        }],
      
        stocks: [{
          brief_desc: '',
          date_acquired: '',
          gfmv: "0.0",
          aod: '0.0',
          nfmv: '0.0',
           pfdp: '0.0',
          pfdr: '0.0',
        }],
      
        retirements: [{
          brief_desc: '',
          date_acquired: '',
          gfmv: "0.0",
          aod: '0.0',
          nfmv: '0.0',
           pfdp: '0.0',
          pfdr: '0.0',
        }],
      
        profit: [{
          brief_desc: '',
          date_acquired: '',
          gfmv: "0.0",
          aod: '0.0',
          nfmv: '0.0',
           pfdp: '0.0',
          pfdr: '0.0',
        }],
      
        accounts: [{
          brief_desc: '',
          date_acquired: '',
          gfmv: "0.0",
          aod: '0.0',
          nfmv: '0.0',
           pfdp: '0.0',
          pfdr: '0.0',
        }],
      
        partnership: [{
          brief_desc: '',
          date_acquired: '',
          gfmv: "0.0",
          aod: '0.0',
          nfmv: '0.0',
           pfdp: '0.0',
          pfdr: '0.0',
        }],
      
        otherAssets: [{
          brief_desc: '',
          date_acquired: '',
          gfmv: "0.0",
          aod: '0.0',
          nfmv: '0.0',
           pfdp: '0.0',
          pfdr: '0.0',
        }],
      
        continuationAssets: [{
          brief_desc: '',
          date_acquired: '',
          gfmv: "0.0",
          aod: '0.0',
          nfmv: '0.0',
           pfdp: '0.0',
          pfdr: '0.0',
        }],
      
        studentLoans: [{
          debt_description: '',
          debts_date_incurred: '',
          debts_total_owing: '0.0',
          debts_pdap: '0.0',
          debts_pdcr: '0.0',
        }],
      
        taxes: [{
          debt_description: '',
          debts_date_incurred: '',
          debts_total_owing: '0.0',
          debts_pdap: '0.0',
          debts_pdcr: '0.0',
        }],
      
        support: [{
          debt_description: '',
          debts_date_incurred: '',
          debts_total_owing: '0.0',
          debts_pdap: '0.0',
          debts_pdcr: '0.0',
        }],
      
        loans: [{
          debt_description: '',
          debts_date_incurred: '',
          debts_total_owing: '0.0',
          debts_pdap: '0.0',
          debts_pdcr: '0.0',
        }],
      
        creditCards: [{
          debt_description: '',
          debts_date_incurred: '',
          debts_total_owing: '0.0',
          debts_pdap: '0.0',
          debts_pdcr: '0.0',
        }],
      
        debts: [{
          debt_description: '',
          debts_date_incurred: '',
          debts_total_owing: '0.0',
          debts_pdap: '0.0',
          debts_pdcr: '0.0',
        }],
      
        continuationDebts: [{
          debt_description: '',
          debts_date_incurred: '',
          debts_total_owing: '0.0',
          debts_pdap: '0.0',
          debts_pdcr: '0.0',
        }]};
    case "SUCCESS_GET_DATA":
      return {
        ...state, isFetchingGetData: false,


        realEstate: isEmpty(find(action.payload.data, { "asset_brief_description_id": 1 }).data) ? state.realEstate : find(action.payload.data, { "asset_brief_description_id": 1 }).data,
        household: isEmpty(find(action.payload.data, { "asset_brief_description_id": 2 }).data) ? state.household : find(action.payload.data, { "asset_brief_description_id": 2 }).data,
        jewelary: isEmpty(find(action.payload.data, { "asset_brief_description_id": 3 }).data) ? state.jewelary : find(action.payload.data, { "asset_brief_description_id": 3 }).data,
        vehicles: isEmpty(find(action.payload.data, { "asset_brief_description_id": 4 }).data) ? state.vehicles : find(action.payload.data, { "asset_brief_description_id": 4 }).data,
        savings: isEmpty(find(action.payload.data, { "asset_brief_description_id": 5 }).data) ? state.savings : find(action.payload.data, { "asset_brief_description_id": 5 }).data,
        checking: isEmpty(find(action.payload.data, { "asset_brief_description_id": 6 }).data) ? state.checking : find(action.payload.data, { "asset_brief_description_id": 6 }).data,
        credit: isEmpty(find(action.payload.data, { "asset_brief_description_id": 7 }).data) ? state.credit : find(action.payload.data, { "asset_brief_description_id": 7 }).data,
        cash: isEmpty(find(action.payload.data, { "asset_brief_description_id": 8 }).data) ? state.cash : find(action.payload.data, { "asset_brief_description_id": 8 }).data,
        taxRefund: isEmpty(find(action.payload.data, { "asset_brief_description_id": 9 }).data) ? state.taxRefund : find(action.payload.data, { "asset_brief_description_id": 9 }).data,
        lifeInsurance: isEmpty(find(action.payload.data, { "asset_brief_description_id": 10 }).data) ? state.lifeInsurance : find(action.payload.data, { "asset_brief_description_id": 10 }).data,
        stocks: isEmpty(find(action.payload.data, { "asset_brief_description_id": 11 }).data) ? state.stocks : find(action.payload.data, { "asset_brief_description_id": 11 }).data,
        retirements: isEmpty(find(action.payload.data, { "asset_brief_description_id": 12 }).data) ? state.retirements : find(action.payload.data, { "asset_brief_description_id": 12 }).data,
        profit: isEmpty(find(action.payload.data, { "asset_brief_description_id": 13 }).data) ? state.profit : find(action.payload.data, { "asset_brief_description_id": 13 }).data,
        accounts: isEmpty(find(action.payload.data, { "asset_brief_description_id": 14 }).data) ? state.accounts : find(action.payload.data, { "asset_brief_description_id": 14 }).data,
        partnership: isEmpty(find(action.payload.data, { "asset_brief_description_id": 15 }).data) ? state.partnership : find(action.payload.data, { "asset_brief_description_id": 15 }).data,
        otherAssets: isEmpty(find(action.payload.data, { "asset_brief_description_id": 16 }).data) ? state.otherAssets : find(action.payload.data, { "asset_brief_description_id": 16 }).data,
        continuationAssets: isEmpty(find(action.payload.data, { "asset_brief_description_id": 17 }).data) ? state.continuationAssets : find(action.payload.data, { "asset_brief_description_id": 17 }).data,
        studentLoans: isEmpty(find(action.payload.data, { "asset_brief_description_id": 18 }).data) ? state.studentLoans : find(action.payload.data, { "asset_brief_description_id": 18 }).data,
        taxes: isEmpty(find(action.payload.data, { "asset_brief_description_id": 19 }).data) ? state.taxes : find(action.payload.data, { "asset_brief_description_id": 19 }).data,
        support: isEmpty(find(action.payload.data, { "asset_brief_description_id": 20 }).data) ? state.support : find(action.payload.data, { "asset_brief_description_id": 20 }).data,
        loans: isEmpty(find(action.payload.data, { "asset_brief_description_id": 21 }).data) ? state.loans : find(action.payload.data, { "asset_brief_description_id": 21 }).data,
        creditCards: isEmpty(find(action.payload.data, { "asset_brief_description_id": 22 }).data) ? state.creditCards : find(action.payload.data, { "asset_brief_description_id": 22 }).data,
        debts: isEmpty(find(action.payload.data, { "asset_brief_description_id": 23 }).data) ? state.debts : find(action.payload.data, { "asset_brief_description_id": 23 }).data,
        continuationDebts: isEmpty(find(action.payload.data, { "asset_brief_description_id": 24 }).data) ? state.continuationDebts : find(action.payload.data, { "asset_brief_description_id": 24 }).data,

      };
    case "ERROR_GET_DATA":
      return { ...state, isFetchingGetData: false };



      case "REQUEST_DELETE_COMMUNITY_ASSETS":
        return { ...state, isFetchingDeleteCommunityAssets: true };
      case "SUCCESS_DELETE_COMMUNITY_ASSETS":
        return {
          ...state,
          isFetchingDeleteCommunityAssets: false,
          realEstate: isEmpty(filter(action.payload.data, {asset_brief_description_id: 1})) ? state.realEstate : filter(action.payload.data, {asset_brief_description_id: 1}),
          household: isEmpty(filter(action.payload.data, {asset_brief_description_id: 2})) ? state.household : filter(action.payload.data, {asset_brief_description_id: 2}),
          jewelary: isEmpty(filter(action.payload.data, {asset_brief_description_id: 3})) ? state.jewelary : filter(action.payload.data, {asset_brief_description_id: 3}),
          vehicles: isEmpty(filter(action.payload.data, {asset_brief_description_id: 4})) ? state.vehicles : filter(action.payload.data, {asset_brief_description_id: 4}),
          savings: isEmpty(filter(action.payload.data, {asset_brief_description_id: 5})) ? state.savings : filter(action.payload.data, {asset_brief_description_id: 5}),
          checking: isEmpty(filter(action.payload.data, {asset_brief_description_id: 6})) ? state.checking : filter(action.payload.data, {asset_brief_description_id: 6}),
          credit: isEmpty(filter(action.payload.data, {asset_brief_description_id: 7})) ? state.credit : filter(action.payload.data, {asset_brief_description_id: 7}),
          cash: isEmpty(filter(action.payload.data, {asset_brief_description_id: 8})) ? state.cash : filter(action.payload.data, {asset_brief_description_id: 8}),
          taxRefund: isEmpty(filter(action.payload.data, {asset_brief_description_id: 9})) ? state.taxRefund : filter(action.payload.data, {asset_brief_description_id: 9}),
          lifeInsurance: isEmpty(filter(action.payload.data, {asset_brief_description_id: 10})) ? state.lifeInsurance : filter(action.payload.data, {asset_brief_description_id: 10}),
          stocks: isEmpty(filter(action.payload.data, {asset_brief_description_id: 11})) ? state.stocks : filter(action.payload.data, {asset_brief_description_id: 11}),
          retirements: isEmpty(filter(action.payload.data, {asset_brief_description_id: 12})) ? state.retirements : filter(action.payload.data, {asset_brief_description_id: 12}),
          profit: isEmpty(filter(action.payload.data, {asset_brief_description_id: 13})) ? state.profit : filter(action.payload.data, {asset_brief_description_id: 13}),
          accounts: isEmpty(filter(action.payload.data, {asset_brief_description_id: 14})) ? state.accounts : filter(action.payload.data, {asset_brief_description_id: 14}),
          partnership: isEmpty(filter(action.payload.data, {asset_brief_description_id: 15})) ? state.partnership : filter(action.payload.data, {asset_brief_description_id: 15}),
          otherAssets: isEmpty(filter(action.payload.data, {asset_brief_description_id: 16})) ? state.otherAssets : filter(action.payload.data, {asset_brief_description_id: 16}),
        };
        
      case "ERROR_DELETE_COMMUNITY_ASSETS":
        return { ...state, isFetchingDeleteCommunityAssets: false };


        case "REQUEST_DELETE_COMMUNITY_DEBITS":
        return { ...state, isFetchingDeleteCommunityDebits: true };
      case "SUCCESS_DELETE_COMMUNITY_DEBITS":
        return {
          ...state,
          isFetchingDeleteCommunityDebits: false,

          studentLoans: isEmpty(filter(action.payload.data, {asset_brief_description_id: 18})) ? state.studentLoans : filter(action.payload.data, {asset_brief_description_id: 18}),
          taxes: isEmpty(filter(action.payload.data, {asset_brief_description_id: 19})) ? state.taxes : filter(action.payload.data, {asset_brief_description_id: 19}),
          support: isEmpty(filter(action.payload.data, {asset_brief_description_id: 20})) ? state.support : filter(action.payload.data, {asset_brief_description_id: 20}),
          loans: isEmpty(filter(action.payload.data, {asset_brief_description_id: 21})) ? state.loans : filter(action.payload.data, {asset_brief_description_id: 21}),
          creditCards: isEmpty(filter(action.payload.data, {asset_brief_description_id: 22})) ? state.creditCards : filter(action.payload.data, {asset_brief_description_id: 22}),
          debts: isEmpty(filter(action.payload.data, {asset_brief_description_id: 23})) ? state.debts : filter(action.payload.data, {asset_brief_description_id: 23}),
        };
      case "ERROR_DELETE_COMMUNITY_DEBITS":
        return { ...state, isFetchingDeleteCommunityDebits: false };
      

    default:
      return state;
  }

}


export default communityPropertyReducer;
